/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleProperty } from './APIArticleProperty';
import {
    APIArticlePropertyFromJSON,
    APIArticlePropertyFromJSONTyped,
    APIArticlePropertyToJSON,
} from './APIArticleProperty';
import type { APIArticleVariation } from './APIArticleVariation';
import {
    APIArticleVariationFromJSON,
    APIArticleVariationFromJSONTyped,
    APIArticleVariationToJSON,
} from './APIArticleVariation';
import type { APINamedEntity } from './APINamedEntity';
import {
    APINamedEntityFromJSON,
    APINamedEntityFromJSONTyped,
    APINamedEntityToJSON,
} from './APINamedEntity';

/**
 * 
 * @export
 * @interface APIArticleSearchResult
 */
export interface APIArticleSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIArticleSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSearchResult
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSearchResult
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSearchResult
     */
    barcodeText?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSearchResult
     */
    qualityClass?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIArticleSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIArticleSearchResult
     */
    isBomBase?: boolean;
    /**
     * 
     * @type {APINamedEntity}
     * @memberof APIArticleSearchResult
     */
    brand?: APINamedEntity;
    /**
     * 
     * @type {APINamedEntity}
     * @memberof APIArticleSearchResult
     */
    articleType?: APINamedEntity;
    /**
     * 
     * @type {APINamedEntity}
     * @memberof APIArticleSearchResult
     */
    family?: APINamedEntity;
    /**
     * 
     * @type {Array<APINamedEntity>}
     * @memberof APIArticleSearchResult
     */
    categories?: Array<APINamedEntity>;
    /**
     * 
     * @type {Array<APIArticleProperty>}
     * @memberof APIArticleSearchResult
     */
    properties?: Array<APIArticleProperty>;
    /**
     * 
     * @type {APIArticleVariation}
     * @memberof APIArticleSearchResult
     */
    variationOf?: APIArticleVariation;
    /**
     * 
     * @type {APINamedEntity}
     * @memberof APIArticleSearchResult
     */
    supplier?: APINamedEntity;
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResult
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResult
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResult
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResult
     */
    height?: number;
}

/**
 * Check if a given object implements the APIArticleSearchResult interface.
 */
export function instanceOfAPIArticleSearchResult(value: object): value is APIArticleSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function APIArticleSearchResultFromJSON(json: any): APIArticleSearchResult {
    return APIArticleSearchResultFromJSONTyped(json, false);
}

export function APIArticleSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'name': json['name'],
        'number': json['number'],
        'description': json['description'] == null ? undefined : json['description'],
        'barcodeText': json['barcode_text'] == null ? undefined : json['barcode_text'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
        'brand': json['brand'] == null ? undefined : APINamedEntityFromJSON(json['brand']),
        'articleType': json['article_type'] == null ? undefined : APINamedEntityFromJSON(json['article_type']),
        'family': json['family'] == null ? undefined : APINamedEntityFromJSON(json['family']),
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(APINamedEntityFromJSON)),
        'properties': json['properties'] == null ? undefined : ((json['properties'] as Array<any>).map(APIArticlePropertyFromJSON)),
        'variationOf': json['variation_of'] == null ? undefined : APIArticleVariationFromJSON(json['variation_of']),
        'supplier': json['supplier'] == null ? undefined : APINamedEntityFromJSON(json['supplier']),
        'weight': json['weight'] == null ? undefined : json['weight'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
    };
}

export function APIArticleSearchResultToJSON(value?: APIArticleSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'name': value['name'],
        'number': value['number'],
        'description': value['description'],
        'barcode_text': value['barcodeText'],
        'quality_class': value['qualityClass'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'is_bom_base': value['isBomBase'],
        'brand': APINamedEntityToJSON(value['brand']),
        'article_type': APINamedEntityToJSON(value['articleType']),
        'family': APINamedEntityToJSON(value['family']),
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(APINamedEntityToJSON)),
        'properties': value['properties'] == null ? undefined : ((value['properties'] as Array<any>).map(APIArticlePropertyToJSON)),
        'variation_of': APIArticleVariationToJSON(value['variationOf']),
        'supplier': APINamedEntityToJSON(value['supplier']),
        'weight': value['weight'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
    };
}

